import React, { useEffect } from "react";
import TeamDetails from "./TeamDetails";
import AOS from "aos";
import "aos/dist/aos.css";

const coreTeam = {

 
  Ayush: {
    image: "/assets/allmembers25/ayush_saware.jpg",
    role: "General Secretary",
    name: "Ayush Saware",
    mail: "sawareayush11@gmail.com",
    linkedin: "https://www.linkedin.com/in/ayush-saware-20408a237"
  },
  Yash: {
    image: "/assets/allmembers25/yash_tapre.jpg",
    role: "President",
    name: "Yash Tapre",
    mail: "yashtapre2004@gmail.com",
    linkedin: "https://www.linkedin.com/in/yash-tapre-236481319"
  }, 
  Gauri: {
    image: "/assets/allmembers25/gauri_shedge.jpg",
    role: "Co-General Secretary",
    name: "Gauri Shedge",
    mail: "gauriushedge19@gmail.com",
    linkedin: "https://www.linkedin.com/in/gauri-shedge-0797892ba"
  },
  Tushar: {
    image: "/assets/allmembers25/tushar_salunke.jpg",
    role: "Convenor",
    name: "Tushar Salunke",
    mail: "salunketushar447@gmail.com",
    linkedin: "http://linkedin.com/in/tushar-salunke-8a9095317"
  },
  Rachana: {
    image: "/assets/allmembers25/rachana_poojari.jpg",
    role: "Convenor",
    name: "Rachana Poojari",
    mail: "poojarirachna@gmail.com",
    linkedin: "https://www.linkedin.com/in/rachana-poojari-348a072a5/"
  },
  AyushCo: {
    image: "/assets/allmembers25/ayush_someshwar.jpg",
    role: "Co-Convenor",
    name: "Ayush Someshwar",
    mail: "ayu.dmce10@gmail.com",
    linkedin: "https://www.linkedin.com/in/ayush-someshwar-661672321/"
  },
  Devendra: {
    image: "/assets/allmembers25/devendra_pathare.jpg",
    role: "Treasurer",
    name: "Devendra Pathare",
    mail: "devendrapathare02@gmail.com",
    linkedin: "https://www.linkedin.com/in/devendra-pathare-5a733b2b8/"
  },
  Sahil: {
    image: "/assets/allmembers25/sahil_supe.jpg",
    role: "Treasurer",
    name: "Sahil Supe",
    mail: "supe.sahil.it061@gmail.com",
    linkedin: "https://www.linkedin.com/in/sahil-supe-aba398370/"
  },
  Mitesh: {
    image: "/assets/allmembers25/mitesh_joshi.jpg",
    role: "Event Head",
    name: "Mitesh Joshi",
    mail: "miteshjoshi5565@gmail.com",
    linkedin: "https://www.linkedin.com/in/mitesh-joshi-1b99b4286/"
  },
  Shridhar: {
    image: "/assets/allmembers25/shridhar_desai.jpg",
    role: "Co-Event Head",
    name: "Shridhar Desai",
    mail: "shridhar.desai024@gmail.com",
    linkedin: "https://www.linkedin.com/in/shridhardesai04"
  },
  Namrata: {
    image: "/assets/allmembers25/namrata_ghadge.jpg",
    role: "Lady Representative",
    name: "Namrata Ghadge",
    mail: "ghadgenamrata24@gmail.com",
    linkedin: "https://www.linkedin.com/in/namrata-ghadge-954864209/"
  },
  Appeksha: {
    image: "/assets/allmembers25/appeksha_suryawanshi.jpg",
    role: "Cultural Head",
    name: "Appeksha Suryawanshi",
    mail: "appeksha.suryawanshi@gmail.com",
    linkedin: "https://www.linkedin.com/in/appeksha-suryawanshi-b9a6182a7/"
  },
  Vedantika: {
    image: "/assets/allmembers25/vedantika_ayare.jpg",
    role: "Co-Cultural Head",
    name: "Vedantika Ayare",
    mail: "vedantikaayare12@gmail.com",
    linkedin: "https://www.linkedin.com/in/vedantika-ayare-12b817312"
  },
  Shree: {
    image: "/assets/allmembers25/shree_vyapari.jpg",
    role: "Sports Head",
    name: "Shree Vyapari",
    mail: "shreevyapari05@gmail.com",
    linkedin: "https://www.linkedin.com/in/shree-vyapari-114042348/"
  },
  Dipak: {
    image: "/assets/allmembers25/dipak_guldagad.jpg",
    role: "Sports Head",
    name: "Dipak Guldagad",
    mail: "dipakguldagad13@gmail.com",
    linkedin: "https://www.linkedin.com/in/dipak-guldagad-8108102ba"
  },
  Kaustubh: {
    image: "/assets/allmembers25/kaustubh_koshti.jpg",
    role: "Documentation Head",
    name: "Kaustubh Koshti",
    mail: "kaustubhkoshti@gmail.com",
    linkedin: "https://www.linkedin.com/in/kaustubh-koshti-/"
  },
  Sangram: {
    image: "/assets/allmembers25/sangram_salunkhe.jpg",
    role: "Documentation Head",
    name: "Sangram Salunkhe",
    mail: "Sangram.salunkhe2004@gmail.com",
    linkedin: "https://www.linkedin.com/in/sangram-salunkhe-41a421322"
  },
  Shreya: {
    image: "/assets/allmembers25/shreya_singh.jpg",
    role: "Design Head",
    name: "Shreya Singh",
    mail: "shreyasingh1427@gmail.com",
    linkedin: "https://www.linkedin.com/in/shreya-singh-8506a625b"
  },
  Sanika: {
    image: "/assets/allmembers25/sanika_chavan.jpg",
    role: "Publicity Head",
    name: "Sanika Chavan",
    mail: "chavansanika312005@gmail.com",
    linkedin: "https://www.linkedin.com/in/sanika-chavan-4605542a4"
  },
  Deven: {
    image: "/assets/allmembers25/deven_atkari.jpg",
    role: "Publicity Head",
    name: "Deven Atkari",
    mail: "devenatkari5@gmail.com",
    linkedin: "https://www.linkedin.com/in/deven-atkari-754a10265"
  },
  TusharG: {
    image: "/assets/allmembers25/tushar_gupta.jpg",
    role: "Social Media Head",
    name: "Tushar Gupta",
    mail: "tushargupta2446@gmail.com",
    linkedin: ""
  },
  Vallika: {
    image: "/assets/allmembers25/vallika_bodekar.jpg",
    role: "Social Media Head",
    name: "Vallika Bodekar",
    mail: "vallikabodekar@gmail.com",
    linkedin: ""
  },
  Vedant: {
    image: "/assets/allmembers25/vedant_kanekar.jpg",
    role: "Sponsorship Head",
    name: "Vedant Kanekar",
    mail: "vedantkanekar909@gmail.com",
    linkedin: "https://www.linkedin.com/in/vedant-kanekar/"
  }
};

const techGits = {
  
 
  Kshitij: {
    image: "/assets/allmembers25/kshitij_sharma.jpg",
    role: "TECH-GITS Head",
    name: "Kshitij Sharma",
    mail: "kshitijsharma092@gmail.com",
    linkedin: "https://www.linkedin.com/in/kshitij-sharma-00b8652b6/"
  }, Ayushkumar: {
    image: "/assets/allmembers25/ayush_Vishwakarma.jpg",
    role: "TECH-GITS Co-Head",
    name: "Ayushkumar Vishwakarma",
    mail: "ayushkumar.vishwakarma19@gmail.com",
    linkedin: "https://www.linkedin.com/in/ayushkumar-vishwakarma-b47b5b335"
  },
  Ashitosh: {
    image: "/assets/allmembers25/ashitosh_sabale.jpg",
    role: "TECH-GITS Co-Head",
    name: "Ashitosh Sabale",
    mail: "sabaleashitosh2004@gmail.com",
    linkedin: "https://www.linkedin.com/in/ashitosh-sabale-b77a522b7/"
  },
  Ram: {
    image: "/assets/allmembers25/ram_shekade.jpg",
    role: "TECH-GITS Member",
    name: "Ram Shekade",
    mail: "ramshekade20@gmail.com",
    linkedin: "https://www.linkedin.com/in/ram-shekade-9505a1266/"
  },
  Kunal: {
    image: "/assets/allmembers25/kunal_patil.jpg",
    role: "TECH-GITS Member",
    name: "Kunal Patil",
    mail: "kunal.patil15072004@gmail.com",
    linkedin: "https://www.linkedin.com/in/kunalpatil1504"
  },
  Isha: {
    image: "/assets/allmembers25/isha_patil.jpg",
    role: "TECH-GITS Member",
    name: "Isha Patil",
    mail: "ishapatil3196@gmail.com",
    linkedin: "https://www.linkedin.com/in/isha-patil-89957524a"
  },
  Atharva: {
    image: "/assets/allmembers25/atharva_rane.jpg",
    role: "TECH-GITS Member",
    name: "Atharva Rane",
    mail: "arane3287@gmail.com",
    linkedin: "https://www.linkedin.com/in/atharva-rane-ba244828a/"
  },
  Vipul: {
    image: "/assets/allmembers25/vipul_patil.jpg",
    role: "TECH-GITS Member",
    name: "Vipul Patil",
    mail: "vipulpatil2500@gmail.com",
    linkedin: "https://www.linkedin.com/in/vipul-space/"
  }
};

const Team2025 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <div className="flex flex-col justify-center items-center mt-20">
      <h1 
        className="font-larabieBold text-6xl text-center text-[#00ffff] mb-10" 
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        GITS Committee 2025–26
      </h1>
      <div className="flex flex-wrap justify-center items-center">
        {Object.entries(coreTeam).map(([key, member], index) => (
          <div 
            className="mx-5 my-5" 
            key={key} 
            data-aos="fade-up" 
            data-aos-delay={100 + (index * 50)}
          >
            <TeamDetails {...member} />
          </div>
        ))}
      </div>

      <h1 
        className="font-larabieBold text-6xl text-center text-[#00ffff] mt-16 mb-10" 
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        TECH-GITS Team
      </h1>
      <div className="flex flex-wrap justify-center items-center">
        {Object.entries(techGits).map(([key, member], index) => (
          <div 
            className="mx-5 my-5" 
            key={key} 
            data-aos="fade-up" 
            data-aos-delay={100 + (index * 50)}
          >
            <TeamDetails {...member} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team2025;